var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDriverW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.778,
    viewBox: "0 0 16 17.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_assignment_ind_24px",
    className: "cls-1",
    d: "M17.222,2.778H13.507a2.656,2.656,0,0,0-5.013,0H4.778A1.783,1.783,0,0,0,3,4.556V17a1.783,1.783,0,0,0,1.778,1.778H17.222A1.783,1.783,0,0,0,19,17V4.556A1.783,1.783,0,0,0,17.222,2.778ZM11,2.778a.889.889,0,1,1-.889.889A.892.892,0,0,1,11,2.778Zm0,3.556A2.667,2.667,0,1,1,8.333,9,2.663,2.663,0,0,1,11,6.333ZM16.333,17H5.667V15.756C5.667,13.978,9.222,13,11,13s5.333.978,5.333,2.756Z",
    transform: "translate(-3 -1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDriverW);
export default __webpack_public_path__ + "static/media/ic_driver_w.49ace2616b8cae261b31647bfbec73d5.svg";
export { ForwardRef as ReactComponent };